var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-gallery",class:_vm.albumClass},_vm._l((_vm.images),function(image,key){return _c('a',{key:key,attrs:{"href":image.src}},[_c('img',{class:_vm.imageClass,attrs:{"src":image.src,"title":image.title,"alt":""}}),_vm._v(" "),_vm._t("default")],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }